import { render, staticRenderFns } from "./BaseImage.vue?vue&type=template&id=65a6daa6&scoped=true"
import script from "./BaseImage.vue?vue&type=script&lang=js"
export * from "./BaseImage.vue?vue&type=script&lang=js"
import style0 from "./BaseImage.vue?vue&type=style&index=0&id=65a6daa6&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65a6daa6",
  null
  
)

export default component.exports